export default __webpack_public_path__ + "static/media/9FD8102C-BEDB-4A86-ABD9-A213B69A73C4.2582b2c1.jpeg";